<template>
  <div class="">
    <Navbar />
    <div class="home-img py-md-2 kova-bg">
      <div class="human-im container">
        <div class="row pt-5 pb-md-5 mt-lg-4">
          <div class="col-sm-12 col-md-6 mt-5 pt-md-5">
            <h3
              class="pt-5 text-white font-weight-bold very-bold1 mx-4 text-capitalize very-bold"
            >
              Let's Make your Hiring Process 5X Faster
            </h3>
            <p
              class="mt-3 ml-sm-5 ml-4 text-white font-size2 font-weight-light"
            >
              TalentAlt helps to fast track your product building.
            </p>
            <div
              class="ctrl-vetted-text banner-add-margin ml-4 mb-5 d-flex mt-4"
            ></div>
            <div class="">
              <!-- <button class="styled-btn btn-dev-signup mt-3 mx-3 px-4 py-2 ctrl-vetted-text text-uppercase font-weight-bold" @click="findTalent">find talent</button>  -->
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="mt-4 mt-md-5 pt-md-4">
              <div class="border px-3 py-4 rounded">
                <h5 class="font-weight-bolder text-white">Sign Up</h5>
                <div class="">
                  <a-input
                    class="mt-3 text-white w-100"
                    size="large"
                    placeholder="Work Email"
                    ref="searchInput"
                    style="background: transparent"
                  ></a-input>
                </div>
                <div class="">
                  <a-input
                    class="mt-3 text-white w-100"
                    size="large"
                    type="password"
                    placeholder="Password"
                    ref="searchInput"
                    style="background: transparent"
                  ></a-input>
                </div>
                <div class="">
                  <a-input
                    class="mt-3 text-white w-100"
                    size="large"
                    type="password"
                    placeholder="Confirm Password"
                    ref="searchInput"
                    style="background: transparent"
                  ></a-input>
                </div>
                <button
                  class="btn-transparent-kovatek px-5 py-2 mt-4 add-rounded"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4 class="pt-5 font-weight-bold kova-text">
      Hire Top Software Engineers for your organization
    </h4>
    <div class="container">
      <div class="control-width">
        <router-view></router-view>
      </div>
    </div>
    <GetHired />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import GetHired from '@/components/GetHired.vue';

export default {
  name: 'findtalent',
  components: {
    Navbar,
    Footer,
    GetHired,
  },
  data() {
    return {
      skills: [
        'React',
        'Angular',
        'Vue',
        'Kotlin',
        'Python',
        'Go',
        'JavaScript',
        'PHP',
        'Nodejs',
        'Django',
        'Flask',
        'Laravel',
        'Java',
        'C#',
        'C++',
        '.NET',
        'Ruby',
        'Scala',
        'Perl',
        'Symfony',
        'Spring',
        'JSF',
        'Others',
      ],

      location: ['Nigeria', 'Kenya', 'United States'],
      stacks: [
        'React',
        'Angular',
        'Vue',
        'Kotlin',
        'Python',
        'Go',
        'JavaScript',
        'PHP',
        'Nodejs',
        'Django',
        'Flask',
        'Laravel',
        'Java',
        'C#',
        'C++',
        '.NET',
        'Ruby',
        'Scala',
        'Perl',
        'Symfony',
        'Spring',
        'JSF',
        'Others',
      ],
      workHistory: [
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
      ],
      proSkills: ['Database', 'Modeling', 'Vue.js'],
      experience: ['Junior Level', 'intermediate Level', 'Senior Level'],
      width: window.innerWidth,
      showDevs: false,
      category: '',
      experienceLevel: '',
      skill: '',
      locate: '',
      message: '',
      htmlForEditor: '',
    };
  },
  methods: {
    findTalent() {
      this.message = `Showing result for ${this.category} Developers with ${
        this.experienceLevel
      }`;
      this.showDevs = true;
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append('file', file);

      this.$http({
        url: 'https://fakeapi.yoursite.com/images',
        method: 'POST',
        data: formData,
      }).then((result) => {
        let url = result.data.url; // Get url from response
        Editor.insertEmbed(cursorLocation, 'file', url);
        resetUploader();
      });
      // .catch(err => {
      // console.log(err);
      // });
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
    });
  },
};
</script>

<style scoped>
.talent-width {
  max-width: 850px;
}
.ctrl-size {
  font-size: 10px;
}
.ctrl-size-1 {
  font-size: 20px;
}
.ctrl-size-2 {
  font-size: 11px;
}
.ctrl-size-3 {
  font-size: 12px;
}
.ctrl-size-4 {
  font-size: 14px;
}
.select-style {
  background: rgba(255, 255, 255, 0.3);
  border: 0;
  color: #fff;
  font-size: 12px;
}
.select-style option {
  background: #eee;
  color: #000;
  border: 0;
  outline: 0;
}
.select-style option:hover {
  background: #20409a;
  border: 0;
  border: 0;
  outline: 0;
}
.btn-new {
  background-color: #2a3f54;
}
/* .home-img{
  background:  url('../assets/KOVATEK/IMAGES/image-031.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
} */

.styled-btn {
  color: #fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
  font-size: 10px;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}
.btn-dev-signup {
  background: linear-gradient(to right, rgb(75, 179, 142), rgb(28, 71, 152));
  border: 0;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: solid #20409a 1px;
  color: #20409a;
  padding-top: 10px;
  font-size: 20px;
}
.control-width {
  width: 600px;
  margin: auto;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
